import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Flex, Box } from "grid-styled";
import InputContainer from "./InputContainer";
import CountrySelect from "./CountrySelect";

const join = (...pathPieces) => pathPieces.filter(piece => !!piece).join(".");

const AddressFields = ({ name, path }) => [
  <Flex key={1} pb={2}>
    <Box width={2 / 3} pr={1}>
      <Field
        name={join(path, "streetAddress")}
        labelText={name}
        placeholder="e.g., 1234 Any St."
        component={InputContainer}
      />
    </Box>
    <Box width={1 / 3} pl={1}>
      <Field
        name={join(path, "aptNumber")}
        labelText="Apt #"
        placeholder="e.g., Suite 101"
        component={InputContainer}
      />
    </Box>
  </Flex>,
  <Flex key={2} pb={2}>
    <Box width={1 / 2} pr={1}>
      <Field
        name={join(path, "city")}
        labelText="City"
        placeholder="e.g., New Orleans"
        component={InputContainer}
      />
    </Box>
    <Box width={1 / 2} pl={1}>
      <Field
        name={join(path, "state")}
        labelText="State"
        placeholder="e.g., LA"
        component={InputContainer}
      />
    </Box>
  </Flex>,
  <Flex key={3} pb={2}>
    <Box width={1 / 2} pr={1}>
      <Field
        name={join(path, "zipCode")}
        labelText="Zip/Postal Code"
        placeholder="e.g., 70032"
        component={InputContainer}
      />
    </Box>
    <Box width={1 / 2} pl={1}>
      <Field
        name={join(path, "country")}
        labelText="Country"
        placeholder="United States of America"
        component={InputContainer}
        fieldComponent={CountrySelect}
      />
    </Box>
  </Flex>
];

AddressFields.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string
};

export default AddressFields;



// WEBPACK FOOTER //
// ./src/components/forms/AddressFields.js